<!-- 现在改到闯关首页调用 -->
<template>
    <div class="kingRoadLoadingBox">
        <div class="loading-content">
            <div class="title"></div>
            <div class="loading-gif-wrapper">
                <div class="loading-gif"></div>
            </div>
            <div class="sub-title">天天挑战 好礼不断</div>
            <div class="loading-symbol">{{ loadingSymbol }}</div>
            <div v-debounce:[handJump]="startEscapeGame" class="jump-btn">点击跳过({{ timer }})</div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
    data() {
        return {
            handJump: true,
            loadingSymbol: '.',
            matchNum: 0,
            addNum: 0,
            matchNumTimer: null,
            timer: 3
        };
    },
    computed: {
        ...mapState(['isPanoReady'])
    },
    mounted() {
        this.startGame(this.timer);
        this.loadingSymbol += '.';
    },
    destroyed() {
        this.matchNumTimer && clearInterval(this.matchNumTimer);
    },
    methods: {
        // 关闭弹窗
        closeDialogBtn() {
            this.$emit('listenToChildEvent');
        },
        startGame(wait) {
            let _this = this;
            let _wait = wait;
            if (wait === 0) {
                this.timer = 0;
                wait = _wait;
                this.startEscapeGame(true);
            }
            else {
                this.timer = wait;
                wait--;
                setTimeout(function () {
                    _this.startGame(wait);
                    _this.loadingSymbol += '.';
                }, 1000);
            }
        },
        // 强制关闭加载态控制，手动关闭时需要全景加载完成，自动加载时会强制关闭加载态自己的标识
        startEscapeGame(closeLoading = false) {
            if (this.isPanoReady || closeLoading) {
                this.$emit('jumpLoading');
            }
        }
    }
};
</script>
<style lang='scss' scoped>
.kingRoadLoadingBox {
    width: 100%;
    height: 100vh;
    background: linear-gradient(178deg, #111A45, #171771);
    display: flex;
    align-items: center;

    .loading-content {
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title {
            width: 375px;
            height: 125px;
            background-size: cover;
            background-repeat: no-repeat;
            background-image: url(../../../../assets/v4/pano/kingRoadLoadingTitle.png);
        }
        .loading-gif-wrapper {
            margin-top: 40px;
            width: 325px;
            height: 275px;
            background-size: cover;
            background-repeat: no-repeat;
            background-image: url(../../../../assets/v4/pano/scanGifFrame.png);
            display: flex;
            justify-content: center;
            align-items: center;
            .loading-gif {
                width: 292px;
                height: 245px;
                background-size: cover;
                background-repeat: no-repeat;
                background-image: url(../../../../assets/v4/pano/scaning.gif);
            }
        }
        .sub-title,
        .loading-symbol {
            margin-top: 30px;
            font-size: 20px;
            font-family: PingFang-SC-Semibold;
            font-weight: 600;
            color: #FFFFFF;
        }
        .loading-symbol {
            margin-top: 0;
        }
        .jump-btn {
            margin-top: 20px;
            width: 100px;
            height: 30px;
            background: rgba(255, 255, 255, 26%);
            padding: 0 10px;
            border-radius:15px;

            color: #0AEEFC;
            font-size: 15px;
            font-family: PingFang-SC-Regular;
            font-weight: normal;

            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>